import {
  startOfMonth,
  startOfWeek,
  endOfMonth,
  endOfWeek,
  addDays,
} from 'date-fns';

export const getMonthMatrix = (
  currentMonth: Date,
  weekStartsOn: 0 | 1 | 2 | 3 | 4 | 5 | 6 = 0,
): Date[] => {
  // Get the start and end of the current month
  const startOfCurrentMonth = startOfMonth(currentMonth);
  const endOfCurrentMonth = endOfMonth(currentMonth);

  // Get the start and end of the calendar view
  const startOfCalendar = startOfWeek(startOfCurrentMonth, { weekStartsOn });
  const endOfCalendar = endOfWeek(endOfCurrentMonth, { weekStartsOn });

  // Generate all visible dates
  const visibleDates: Date[] = [];
  let currentDate = startOfCalendar;

  while (currentDate <= endOfCalendar) {
    visibleDates.push(currentDate);
    currentDate = addDays(currentDate, 1); // Increment by 1 day
  }

  return visibleDates;
};
